import { render, staticRenderFns } from "./ZoneColorIcons.vue?vue&type=template&id=e504c18c"
import script from "./ZoneColorIcons.vue?vue&type=script&lang=js"
export * from "./ZoneColorIcons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports